import {IBaseFetchOptions, IBaseParameters, IEndpointsMap, IBaseResponse} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_DDC: {
		path: 'ddc',
		method: 'GET'
	}
};

export interface IGetWorldpayDDCOptions extends IBaseFetchOptions {
	parameters?: IBaseParameters & {
		c_cardNumber: string;
	};
}

export interface IGetWorldpayResponse extends IBaseResponse{
	JWT: string;
}
